import { Router } from '@angular/router';
import { inject, Injector, runInInjectionContext, Signal } from '@angular/core';
import { MethodError } from '@lentau/core/api/application';
import { UrlsEnum } from '@lentau/ui-kit/core/enums/route.enum';
import { sendCartErrorAnalytic } from '@lentau/cart/analytic/service/errors/cart-error-analytic.loader';
import { ANALYTIC_EVENT_LABELS } from '@lentau/analytics/events/shared';
import { handleCheckoutApiError } from '@lentau/order/checkout-by-step/analytic/errors/handle-errors';
import { IS_ORDER_UPDATING } from '@lentau/order/shared/tokens/is-order-editing.token';
import { CartApiMethods } from '../shared/consts';
import { handleMobileCheckoutB2bErrors } from '@lentau/checkout/application/analytics/handle-errors';

/**
 * Отправляем аналитику ошибок апи в зависимости от страницы
 * здесь все должно быть лейзи
 * */
export async function sendErrorAnalyticByRoute(error: MethodError, injector: Injector) {
  const { url } = inject(Router);
  const isOrderUpdating: Signal<boolean> = inject(IS_ORDER_UPDATING);

  /**
   * Нужно отправлять кастомное событие до старта редактирование при ошибке бэка
   * */
  if (error.url.includes(CartApiMethods.CartFromOrderAdd)) {
    runInInjectionContext(injector, () => sendCartErrorAnalytic(error, ANALYTIC_EVENT_LABELS.order, false));

    return;
  }

  if (isOrderUpdating()) {
    runInInjectionContext(injector, () => sendCartErrorAnalytic(error, ANALYTIC_EVENT_LABELS.cart, true));

    return;
  }

  if (url.startsWith(UrlsEnum.BasketPage)) {
    runInInjectionContext(injector, () => sendCartErrorAnalytic(error, ANALYTIC_EVENT_LABELS.cart, false));

    return;
  }

  if (url.startsWith(UrlsEnum.OrderingPage)) {
    const pageName: string = await handleCheckoutApiError(error, injector);
    runInInjectionContext(injector, () => {
      sendCartErrorAnalytic(error, pageName, false);
      handleMobileCheckoutB2bErrors(error, injector);
    });

    return;
  }
}
